import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Plus, EditSquare } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectWork } from '../../Api/selectors';
import { addParentCompany, addSubCompanyToCompany } from '../actions';
import { REQUEST_COMPANY_SET_PARENT_COMPANY, REQUEST_COMPANY_SET_SUB_COMPANY } from '../constants';
import { selectCompanies } from '../selectors';
import { CompanySelection } from './CompanySelection';
import cn from 'classnames';
import styles from './CompanyStructureSelection.module.css';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const STATE = {
  edit: false,
  selectedCompany: null,
};

const Container = styled.div`
  width: 100%;
  .title {
    white-space: nowrap;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyStructureSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    console.log('click');
    console.log('STATE', STATE);
    this.setState({ ...STATE });
  }

  get company() {
    return this.props.company;
  }

  get empty() {
    if (this.props.relation == 'parent') return !this.company?.parentCompanies?.length;
    return !this.company.subCompanies?.length;
  }

  get work() {
    if (this.props.relation == 'parent') return this.props.workParent;

    return this.props.workSub;
  }

  applySelection() {
    this.props.addCompanyRelation(this.state.selectedCompany.id, this.reset.bind(this));
  }

  render() {
    if (this.work) return <Loader small />;
    return (
      <Container className={cn(`structure-selection ${this.props.relation} ${this.empty ? 'empty' : ''}`, styles.container)}>
        <Button isPrimary onClick={this.setStateFn({ edit: true })} className={styles.button} small={this.props.variant}>
          {this.props.variant === 'sync' && <EditSquare />}
          {!this.props.variant && (
            <>
              <Plus /> {this.lbl(`company.details.structure.${this.props.relation}`)}
            </>
          )}
        </Button>
        {this.renderEdit()}
      </Container>
    );
  }

  renderEdit() {
    if (!this.state.edit) return false;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl(`company.details.structure.${this.props.relation}`)}>
        {this.state.selectedCompany ? (
          <>{this.state.selectedCompany.name}</>
        ) : (
          <CompanySelection company={this.props.company} onSelect={selectedCompany => this.setState({ selectedCompany })} />
        )}
        <div className="d-flex gap-2" style={{marginTop: '54px'}}>
          <ButtonComponent
            style="ButtonSoftEdit"
            onClick={this.applySelection.bind(this)}
            primary
            disabled={!this.state.selectedCompany}
          >
            {this.lbl('ok')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CompanyStructureSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companies: selectCompanies(),
    workSub: selectWork(REQUEST_COMPANY_SET_SUB_COMPANY),
    workParent: selectWork(REQUEST_COMPANY_SET_PARENT_COMPANY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addCompanyRelation(company_id, callback) {
      let companyId = ownProps.company.id;
      if (ownProps.relation === 'parent') {
        let parentCompanyId = company_id;
        dispatch(addParentCompany(companyId, parentCompanyId, callback));
      } else {
        let subCompanyId = company_id;
        dispatch(addSubCompanyToCompany(companyId, subCompanyId, callback));
      }
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyStructureSelection = compose(withConnect, withRouter)(CompanyStructureSelectionComp);
